// gallery.js

$(document).ready(function() {
  if ($('#js-gallery').length) {
    var top = $('[id=\'gallery\']').offset().top;

    $('.js-gallery-link').fancybox({
      width: '100%',
      margin: [10, 10, 10, 10],
      padding: [10, 10, 10, 10],
      openEffect: 'elastic',
      closeEffect: 'elsstic',
      prevEffect: 'fade',
      nextEffect: 'fade',
      closeBtn: false,
      arrows: true,
      helpers: {
        overlay: {
          css: {
            'background': 'rgba(255, 255, 255, 0.85)',
          },
        },
        title: {
          type: 'inside',
        },
        buttons: {
        },

      },
      afterShow: function() {
        $('.fancybox-wrap').swipe({
          swipe: function(event, direction) {
            if (direction === 'left' || direction === 'up') {
              $.fancybox.prev( direction );
            } else {
              $.fancybox.next( direction );
            }
          },

        });
      },
      afterLoad: function() {
        var comment = $(this.element).data('comment');
        var title = $(this).attr('title');

        this.title = (title ? '<i class="icon-leaf"></i> ' + title + ' ' : '') +
         (comment ? '' + comment + '' : '') + '<strong class="float-right">' +
        (this.index +1) + '/' + (this.group.length) + '</strong>';
      },
      beforeClose: function() {
        $('html, body').animate({scrollTop: (top)}, 500);
      },

    });
  }
});

//
// EOF
//
